var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/penfold_icon.png"),"alt":"Penfold"}}),_c('br'),_c('img',{staticClass:"text",attrs:{"src":require("../assets/penfold_text.png"),"alt":"Penfold"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }